export default __webpack_public_path__ + "src/docs/services.pdf";